import * as React from "react"

export const Newsletter = () => {
  return (
    <div className="has-background-light px-5 py-5 blog-sidebar">
      <NewsletterContent />
    </div>
  )
}

export const NewsletterContent = () => {
  return (
    <>
      <h2 className="is-size-4 has-text-weight-bold pb-4 my-0">
        Get the Spring newsletter
      </h2>
      <p className="py-0 pb-4 my-0">
        Stay connected with the Spring newsletter
      </p>
      <p className="py-0 my-0">
        <a
          href="https://go-vmware.broadcom.com/tnz-spring-newsletter-subscribe"
          className="button is-spring"
        >
          Subscribe
        </a>
      </p>
    </>
  )
}
